import { isNil } from 'lodash';
import React from 'react';
import { useRecoilValue } from 'recoil';
import {
  blockDateRange,
  blockDisplayHeader,
  blockLimitedRequestSubjects,
  blockMetrics,
  customizedBlock,
} from 'venn-state';
import { CORRELATION_BLOCK_PRO_FORMA_METRICS, isHistoricalSubject } from 'venn-utils';
import { Block } from '../../components/core';
import { BenchmarkType } from '../../components/secondary/benchmark-type';
import { DefaultDateRange } from '../../components/secondary/date-ranges';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';

const useForceShowSubjects = (id: string) => {
  const selectedMetric = useRecoilValue(blockMetrics(id))[0];
  const subject = useRecoilValue(blockLimitedRequestSubjects(id))[0];

  const isSubjectHistoricalPortfolio = !isNil(subject) && isHistoricalSubject(subject);
  const isProFormaMetric = !isNil(selectedMetric) && CORRELATION_BLOCK_PRO_FORMA_METRICS.includes(selectedMetric);

  return isSubjectHistoricalPortfolio && isProFormaMetric;
};

export const CorrelationHeader = ({ id }: { id: string }) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { selectedMetrics, relativeToBenchmark, subHeader } = useRecoilValue(customizedBlock(id));
  const dateRange = useRecoilValue(blockDateRange(id));
  const forceShowSubjects = useForceShowSubjects(id);

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>

        <Block.Metadata id={id}>
          <DefaultDateRange dateRange={dateRange} />
          <BenchmarkType id={id} />
          {relativeToBenchmark && <Block.MetadataItem iconType="calculator">Relative to Benchmark</Block.MetadataItem>}
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects
        id={id}
        metric={selectedMetrics[0]! || ''}
        relativeToBenchmark={relativeToBenchmark}
        forceShowSubjects={forceShowSubjects}
      />
    </>
  );
};
